export const LOYALTIES_TARGET = 'loyalties';

export const REDEEMS_TARGET = 'redeems';

export const CURRENT_POINTS_TARGET = 'currentPoints';

export const LOYALTY_LEVELS_TARGET = 'loyaltyLevels';
